import * as yup from 'yup';

const REQUIRED_MESSAGE = 'Обязательно для заполнения';
const MAX_FILE_SIZE_BYTES = 25 * 1024 * 1024;

const xlsxFileSchema = yup
  .mixed<File>()
  .nullable()
  .required('Необходимо выбрать файл')
  .test('fileType', 'Допустим только формат .xlsx', (value) =>
    value ? value.name.toLowerCase().endsWith('.xlsx') : true,
  )
  .test('fileSize', 'Размер файла не должен превышать 25 МБ', (value) =>
    value ? value.size <= MAX_FILE_SIZE_BYTES : true,
  );

export const validationSchema = yup.object({
  period: yup
    .array()
    .test('required', 'Укажите начало и конец периода', (value) => !!value?.[0] && !!value?.[1]),
  merchant: yup.number().nullable().required(REQUIRED_MESSAGE),
  provider: yup.number().nullable().required(REQUIRED_MESSAGE),
  direction: yup.string().nullable().required(REQUIRED_MESSAGE),
  providerFile: xlsxFileSchema,
  merchantFile: xlsxFileSchema,
});
